"use client";

import type { UserId } from "@nimble/datamodel/types/userId";
import { CACHE_REVALIDATE_5_MIN_MS } from "@nimble/react-requests/api-clients/caching-strategy";
import { ConnectionsCountResponse } from "@nimble/recommendation-client/types";
import { useQuery, type UseQueryOptions } from "@tanstack/react-query";

import { getConnectionsCount } from "@/lib/api-clients/recommendation-api-client";

export function getConnectionsCountQueryKey(userId: UserId | undefined) {
  return ["connectionsCount", userId];
}

type UseConnectionsCountOptions = Omit<
  UseQueryOptions<ConnectionsCountResponse>,
  "queryKey" | "queryFn"
>;

export function useConnectionsCount(
  userId: UserId | undefined,
  options?: UseConnectionsCountOptions,
) {
  const queryOptions = options ?? {};

  return useQuery({
    queryKey: getConnectionsCountQueryKey(userId),
    queryFn: async () => {
      if (!userId) throw new Error("userId is required");
      const response = await getConnectionsCount(userId);
      return response.data;
    },
    enabled: !!userId,
    staleTime: CACHE_REVALIDATE_5_MIN_MS,
    ...queryOptions,
  });
}
